import React, { useEffect, useRef, useState } from 'react';
import { ButtonSubmit } from './button/Button';
import { FormPanel } from './form_panel';
import { Label } from './input/Label';
import { LabelValidation } from './label_validation';

export interface Props {
  onFacadeNameSelected: (facade: string) => void;
}

export const FormAddProductFacade = (props: Props) => {
  const [facadeName, setFacadeName] = useState('');
  const [showFacadeNameValidation, setShowFacadeNameValidation] = useState(false);

  const firstUpdate = useRef(true);

  const validateFacadeName = () => {
    const validFacadeName = facadeName.length > 0;
    setShowFacadeNameValidation(!validFacadeName);
    return validFacadeName;
  };

  useEffect(() => {
    if (!firstUpdate.current) {
      validateFacadeName();
    }
  }, [facadeName]);

  const submit = () => {
    if (validateFacadeName()) {
      props.onFacadeNameSelected(facadeName);
    }
  };

  return (
    <FormPanel>
      <Label>Facade Name</Label>

      <input
        onChange={(e) => setFacadeName(e.target.value)}
        style={{ marginBottom: '.15rem', width: '25rem' }}
      />
      <LabelValidation show={showFacadeNameValidation} style={{ marginBottom: '1rem' }}>Please enter a facade name.</LabelValidation>

      <ButtonSubmit onClick={() => submit()} text="Add Facade" />
    </FormPanel>
  );
};
